import { DateTime } from "luxon";
import React from "react";
import { StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { getImagesFromCondition } from "./getImagesFromCondition";
import { graphql, useFragment } from "react-relay";
import {
  WidgetWeatherBackground_WidgetWeather$key,
  WidgetWeatherCondition,
} from "./__generated__/WidgetWeatherBackground_WidgetWeather.graphql";
import { ImageBackground } from "expo-image";
const colorStyles = {
  GREAT: ["#A0C6FF", "#B1D0FF"],
  GOOD: ["#7FA0D2", "#7BA4E1"],
  BAD: ["#7C8FAC", "#B6C5DB"],
  SUPERBAD: ["#7C8FAC", "#697C99"],
};

export const colorMapping: { [key in WidgetWeatherCondition]: string[] } = {
  CLEAR_SKY: colorStyles.GREAT,
  FEW_CLOUDS: colorStyles.GREAT,
  SCATTERED_CLOUDS: colorStyles.GOOD,
  BROKEN_CLOUDS: colorStyles.BAD,
  SHOWER_RAIN: colorStyles.BAD,
  RAIN: colorStyles.SUPERBAD,
  THUNDERSTORM: colorStyles.SUPERBAD,
  SNOW: colorStyles.SUPERBAD,
  MIST: colorStyles.SUPERBAD,
};
export function WidgetWeatherBackground(props: {
  widget: WidgetWeatherBackground_WidgetWeather$key;
}) {
  const widget = useFragment(
    graphql`
      fragment WidgetWeatherBackground_WidgetWeather on WidgetWeather {
        currentOccasion {
          condition
        }
      }
    `,
    props.widget
  );
  const currentCondition = widget.currentOccasion?.condition ?? "CLEAR_SKY";
  const isNight = DateTime.local().hour < 6 || DateTime.local().hour > 20;

  return (
    <>
      <LinearGradient
        style={{
          flex: 1,
          ...StyleSheet.absoluteFillObject,
        }}
        colors={
          isNight ? ["#002E73", "#002864"] : colorMapping[currentCondition]
        }
      />
      <ImageBackground
        contentFit="cover"
        style={{
          flex: 1,
          ...StyleSheet.absoluteFillObject,
        }}
        source={getImagesFromCondition(currentCondition, isNight).background}
      />
    </>
  );
}
